<template>
  <v-container fluid>
    <v-row v-if="!show_quote">
      <v-col cols="0" lg="1" sm="0">
      </v-col>
      <v-col cols="12" lg="6" md="12" sm="12">
        <ProductSelect
          @submit="addClubToQuote"
        >
          <template v-slot:title>
            Select Your Clubs
          </template>
          <template v-slot:subtitle>
            <p>Start by selecting the club you would like to trade/sell.</p>
          </template>
          <template v-slot:footer>
            <p>
              If you cannot find the club you are looking for, please contact us
              with your trade in request at
              <a href="mailto:sales@capitalgolfexchange.com"
                >sales@capitalgolfexchange.com</a
              >
            </p>
          </template>
        </ProductSelect>
      </v-col>
      <v-col cols="12" lg="4" md="12" sm="12">
        <CartPreview
          @get-quote="show_quote = true"
        ></CartPreview>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="1">
      </v-col>
      <v-col cols="10">
        <Quote
          @add-more="show_quote=false"
        >
        </Quote>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CartPreview from '../components/CartPreview.vue';
import Quote from '../components/Quote.vue';
import ProductSelect from '../components/ProductSelect';


export default {
  name: 'AddClubs',

  components: {
    ProductSelect,
    CartPreview,
    Quote
  },

  data: () => ({
    show_quote: false,
  }),
  methods: {
    addClubToQuote(productDetails) {
      this.$store.commit("add_cart_item", productDetails);
    },
  },
};
</script>
